<ng-container *ngIf="isLoaded()">
  <!-- Formularios en tarea o en modal sin wrapper -->
  <ng-container *ngIf="task; else noTaskTemplate">
    <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
  </ng-container>

  <ng-template #noTaskTemplate>
    <ng-container *ngIf="!windowHash; else popUp">
      <div class="wrapper wrapper-content BASEFORMINMODAL">
        <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #popUp>
    <ng-container>
      <sub-header [includeContextHelp]="true" [isModal]="true" [windowHash]=this.windowHash></sub-header>
      <p-scrollPanel [style]="{width: '100%', height: '80vh'}" styleClass="custombar1">
        <div class="container-fluid pb-md">
          <ng-container *ngTemplateOutlet="formTemplate"></ng-container>
        </div>
      </p-scrollPanel>
    </ng-container>
  </ng-template>


  <ng-template #formTemplate>
    <div class="col-2" *ngIf="locale !== null && (!this.project || this.project.locale !== locale)">
      <label>{{ 'Languages.language' | translate }}</label>
      <div style="padding: em 1em">
        <img style="vertical-align: middle; margin-right: .5em" src="assets/img/{{locale}}.gif" height="20px" />
        <span>{{ ('Languages.' + locale) | translate}}</span>
      </div>
    </div>

    <div id="procedureCircuit">
      <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig" class="row"></formPlyca>
      <ng-container *ngTemplateOutlet="stepsTemplate"></ng-container>
    </div>
  </ng-template>
</ng-container>

<ng-template #stepsTemplate>
  <ng-container *ngIf="showCircuits()">
    <div class="row m-t-sm">
      <!-- ANEXAR CUMPLIMENTAR -->
      <div class="col-12 col-sm-6">
        <span *ngIf="!this.model.procedureCircuit?.circuit?.documentClass?.configuration?.table ||
        this.model.procedureCircuit?.circuit?.documentClass?.configuration?.table === 'DOCNOESTRUC'">
          <span class="align-middle">{{'ProcedureCircuit.Msg.NewDoc' | translate}}</span>
          <p-selectButton [options]="selectAddDocument" [(ngModel)]="addDocumentSelection" optionLabel="name"
            optionValue="code" (onChange)="changeAddDocument($event)" styleClass="d-inline m-l-sm"
            [disabled]="this.model.procedureCircuit?.orderNumber !== undefined"></p-selectButton>
        </span>
      </div>
      <!-- ANYADIR PASO -->
      <div class="col-12 col-xs-6 d-flex justify-content-end">
        <!-- <span>
  <span class="align-middle"> {{'ProcedureCircuit.Lbl.AdvancedMode' | translate}}</span>
  <p-inputSwitch [(ngModel)]="model.procedureCircuit.circuit.config.advancedMode"></p-inputSwitch>
</span> -->
        <span class="m-l-md">
          <button type="button" pButton icon="fas fa-plus" label="Añadir tarea" (click)="stepMenu.toggle($event)"
            class="btn btn-sm btn-primary"></button>
        </span>
        <p-menu #stepMenu [model]="stepTypes" [popup]="true" appendTo="body"></p-menu>
      </div>
    </div>
    <div class="row m-t-md" *ngIf="this.addDocumentSelection">
      <div class="col-12">
        <p-table [value]="[1]" [paginator]="false" [responsive]="true" class="footer-over-pagination mb-3">
          <ng-template pTemplate="body" let-idx="rowIndex" let-step let-columns>
            <tr class="circuit-no-border">
              <td style="width: 3%">
              </td>
              <td style="width: 10%">
                <span class="p-column-title">{{stepTableColumns[0]}}</span>
                <span>{{'ProcedureCircuit.Lbl.Cumplimentar' | translate}}</span>
              </td>
              <td style="width: 87%">
                <div class="d-flex justify-content-start w-75">
                  <button class="btn btn-sm btn-outline-primary w-25" aria-expanded="false"
                    title="{{ 'General.add' | translate}}" (click)="showAddDocument()"
                    [attr.disabled]="(this.model?.document?.identifier) ? 'disabled': undefined ">
                    <i class="fas fa-plus" aria-hidden="true"></i> {{ 'General.add' | translate}}
                  </button>
                  <button class="btn btn-sm btn-outline-primary w-25 m-l-sm" aria-expanded="false"
                    title="{{ 'General.view' | translate}}" (click)="showDocument()"
                    [attr.disabled]="(!this.model?.document?.identifier) ? 'disabled': undefined ">
                    <i class="fas fa-eye" aria-hidden="true"></i> {{ 'General.view' | translate}}
                  </button>
                  <button class="btn btn-sm btn-outline-primary w-25 m-l-sm" aria-expanded="false"
                    title="{{ 'General.delete' | translate}}" (click)="deleteDocument()"
                    [attr.disabled]="(!this.model?.document?.identifier || this.model.orderNumber !== undefined) ? 'disabled': undefined">
                    <i class="fa fa-trash" aria-hidden="true"></i> {{ 'General.delete' | translate}}
                  </button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <!-- PASOS DEL CIRCUITO -->
    <div class="row m-t-md" *ngIf="visibleStepsExists()">
      <div class="col-12">
        <p-table [value]="model.procedureCircuit?.circuit?.config?.listCircuitStepDTO" [paginator]="false"
          [responsive]="true" class="footer-over-pagination mb-3">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 3%">#<span class="invisible">{{'ProcedureCircuit.Msg.StepNum' | translate}}</span>
              </th>
              <th style="width: 10%">{{stepTableColumns[0]}}</th>
              <th style="width: 40%">{{stepTableColumns[1]}}</th>
              <th style="width: 40%">{{stepTableColumns[2]}}</th>
              <th style="width: 7%">{{stepTableColumns[3]}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-idx="rowIndex" let-step let-columns>
            <tr [ngClass]="(isMessageStep(step) && model.procedureCircuit?.circuit?.config?.advancedMode)
        ? 'circuit-no-border' : undefined "
              *ngIf="step.typeStep !== TypeStepDTO.Anexa && (step.typeStep !== TypeStepDTO.Cumplimenta || !addDocumentSelection)">
              <td>
                <span class="badge badge-primary">{{ idx + 1 }}</span>
              </td>
              <td>
                <span class="p-column-title">{{stepTableColumns[0]}}</span>
                <span>{{ ('Procedures.stepType.' + step.typeStep) | translate }}</span>
              </td>
              <td>
                <span class="p-column-title">{{stepTableColumns[1]}}</span>
                <formElement [model]="step" [fieldConfig]="getProfileFieldConfig(idx, step)"
                  (valueChanged)="suggestInbox(step)"></formElement>
              </td>
              <td>
                <span class="p-column-title">{{stepTableColumns[2]}}</span>
                <formElement [model]="step" [fieldConfig]="getInboxFieldConfig(idx, step)"></formElement>
              </td>
              <td>
                <span class="p-column-title">{{stepTableColumns[3]}}</span>
                <span class="btn-group float-right">
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false" title="Añadir pausa"
                    (click)="addMessageStep(step.typeStep, idx +1)"
                    *ngIf="isVisibleAddMsgStep(model.procedureCircuit.circuit.config.listCircuitStepDTO, idx)"
                    [attr.disabled]="(isDisabledAddMsgStep(model.procedureCircuit.circuit.config.listCircuitStepDTO, idx))? 'disabled' : undefined">
                    <i class="far fa-comment-dots"></i>
                  </button>
                  <button class="btn btn-sm btn-primary t-action-button" aria-expanded="false"
                    title="{{ 'General.delete' | translate}}" (click)="removeStep(idx)"
                    *ngIf="step.typeStep !== TypeStepDTO.Anexa && step.typeStep !== TypeStepDTO.Cumplimenta">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </span>
              </td>
            </tr>
            <!-- FILA DE MENSAJE -->
            <tr *ngIf="model.procedureCircuit?.circuit?.config?.advancedMode && isMessageStep(step)">
              <td></td>
              <td></td>
              <td colspan="2">
                <span class="p-column-title"> {{'ProcedureCircuit.Lbl.Msg' | translate}}</span>
                <formElement [model]="step" [fieldConfig]="getMessageTextFieldConfig(idx)"></formElement>
              </td>
              <td></td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{'ProcedureCircuit.Msg.SinTareas' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <!-- PUBLICACIONES-->
    <div class="row m-t-md" *ngIf="showPublications">
      <div class="col-12">
        <p-table [value]="dummyArray" [paginator]="false" [responsive]="true" class="footer-over-pagination mb-3">
          <ng-template pTemplate="header">
            <tr class="invisible">
              <th style="width: 3%"></th>
              <th style="width: 10%"> {{pubTableColumns[0]}}</th>
              <th style="width: 80%"> {{pubTableColumns[1]}}</th>
              <th style="width: 7%"> {{pubTableColumns[2]}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-idx="rowIndex">
            <tr class="circuit-no-border">
              <td></td>
              <td>
                <span class="p-column-title">{{pubTableColumns[0]}}</span>
                {{'ProcedureCircuit.Lbl.Publish' | translate}}
              </td>
              <td>
                <span class="p-column-title">{{pubTableColumns[1]}}</span>
                <p-multiSelect [options]="publicationItems"
                  [(ngModel)]="model.procedureCircuit.circuit.config.publications" dataKey="activity.identifier">
                </p-multiSelect>
              </td>
              <td>
                <span class="p-column-title">{{stepTableColumns[2]}}</span>
                <span class="btn-group float-right">
                  <button class="btn btn-sm btn-outline-secondaryt-action-button" aria-expanded="false"
                    title="{{ 'General.delete' | translate}}" (click)="removePublications()"
                    *ngIf="!model.mustBePublished">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <!-- COMUNICACIONES -->
    <div class="row m-t-md" *ngIf="showNotifications">
      <div class="col-12">
        <p-table [value]="dummyArray" [paginator]="false" [responsive]="true" class="footer-over-pagination mb-3">
          <ng-template pTemplate="header">
            <tr class="invisible">
              <th style="width: 3%"></th>
              <th style="width: 10%">{{commTableColumns[0]}}</th>
              <th style="width: 80%">{{commTableColumns[2]}}</th>
              <th style="width: 7%">{{commTableColumns[2]}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-idx="rowIndex" let-notification>
            <tr class="circuit-no-border">
              <td></td>
              <td>
                <span class="p-column-title">{{commTableColumns[0]}}</span>
                {{'ProcedureCircuit.Lbl.Comunicar' | translate}}
              </td>
              <td>
                <span class="p-column-title">{{commTableColumns[1]}}</span>
                <p-dropdown [options]="notificactionItems" [(ngModel)]="model.notificationConfigSelection"
                  [attr.disabled]="(notificactionItems.length === 1) ? 'disabled' : undefined"
                  inputId="notificationsConfig" emptyMessage="{{ 'General.noData' | translate  }}"></p-dropdown>
              </td>
              <td>
                <ng-container *ngIf="!this.notificationCompany">
                  <span class="p-column-title">{{commTableColumns[2]}}</span>
                  <span class="btn-group float-right">
                    <button class="btn btn-sm btn-primary t-action-button" icon="fas fa-plus"
                      label="Añadir destinatario" (click)="receiverMenu.toggle($event)">
                      <i class="fas fa-plus" aria-hidden="true"></i>
                    </button>
                    <p-menu #receiverMenu [model]="notificationReceiverTypes" [popup]="true" appendTo="body"></p-menu>
                    <button class="btn btn-sm btn-outline-secondaryt-action-button" aria-expanded="false"
                      title="{{ 'General.delete' | translate}}" (click)="removeNotifications()"
                      *ngIf="!model.mustBeNotified">
                      <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                  </span>
                </ng-container>
              </td>
            </tr>
            <tr *ngIf="receiversModel?.length > 0">
              <td colspan="2"></td>
              <td colspan="2">
                <p-table [value]="receiversModel" [paginator]="false" [responsive]="true"
                  class="footer-over-pagination mb-3">
                  <ng-template pTemplate="header">
            <tr>
              <th style="width: 90%;">{{receiversColumns[0]}}</th>
              <th style="width: 10%;" class="invisible">{{receiversColumns[1]}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-idx="rowIndex" let-receiver>
            <tr>
              <td>
                <span class="p-column-title">{{receiversColumns[0]}}</span>
                <span>{{getReceiverDescription(receiver)}}</span>
              </td>
              <td>
                <span class="p-column-title">{{receiversColumns[1]}}</span>
                <span class="btn-group float-right">
                  <button class="btn btn-sm btn-outline-secondaryt-action-button" aria-expanded="false"
                    title="{{ 'General.delete' | translate}}" (click)="removeReceiver(receiver)">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
        </td>
        </tr>
</ng-template>
</p-table>
</div>
</div>
</ng-container>
</ng-template>

<!-- DIALOGO GUARDAR CIRCUITO-->
<p-dialog [(visible)]="showSaveCircuit" [showHeader]="true" header="Datos del circuito" [closeOnEscape]="true"
  [modal]=" true" [draggable]="false" [appendTo]="'body'" [responsive]="true" [focusOnShow]="true"
  [style]="{width: '60vw'}" *ngIf="isLoaded()">
  <div class="container-fluid pb-5">
    <div class="row">
      <div class="alert alert-info col-12">
        <span><i class="fas fa-info-circle mr-2" aria-hidden="true"></i>{{'ProcedureCircuit.Msg.SaveInfo' |
          translate}}</span>
      </div>
      <!-- UNIDAD APLICACION -->
      <div class="col-12">
        <formElement [model]="this" [fieldConfig]="orgUnitFieldConfig" [functions]="getUnitFieldFunctions()">
        </formElement>
      </div>
      <!-- NOMBRE DEL CIRCUITO -->
      <div class="col-12">
        <div class="plycaFormField col-12">
          <span><label for="selectedSaveCircuit">{{'General.name' | translate}}</label></span>
          <div class="p-inputgroup">
            <p-dropdown [options]="circuitsToSave" [(ngModel)]="selectedSaveCircuit" editable="true"
              inputId="selectedSaveCircuit" styleClass="w-100" maxlength="200"
              (onChange)="changeSaveCircuitName($event)"
              emptyMessage="{{ 'General.noData' | translate  }}"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="col-12  d-flex justify-content-center">
        <button class="btn btn-sm btn-primary" aria-expanded="false" title="{{ 'General.save' | translate}}"
          (click)="saveCircuit()"
          [attr.disabled]="(!organizationalUnitToSave?.identifier || !selectedSaveCircuit) ? 'disabled': undefined">
          <i class="fas fa-save" aria-hidden="true"></i> {{ 'General.save' | translate}} </button>
      </div>
    </div>
  </div>
</p-dialog>
<p-dialog [(visible)]="showImportCircuit" [showHeader]="true" header="Importar circuito" [closeOnEscape]="true"
  [modal]=" true" [draggable]="false" [appendTo]="'body'" [responsive]="true" [focusOnShow]="true"
  [style]="{width: '60vw'}">
  <div class="container-fluid pb-5">
    <div class="row">
      <div class="alert alert-info col-12">
        {{'ProcedureCircuit.Msg.ImportInfo' | translate}}
      </div>
      <div class="col-12 m-t-sm">
        <p-dropdown id="circuits" [options]="circuits" [(ngModel)]="circuitToImport" class="plForm-element"
          [style]="{ width: '100%' }" [ngModelOptions]="{ standalone: true }"
          emptyMessage="{{ 'General.noData' | translate  }}">
        </p-dropdown>
      </div>
      <div class="col-12 m-t-sm d-flex justify-content-center">
        <button class="btn btn-sm btn-primary" aria-expanded="false" title="{{ 'General.save' | translate}}"
          (click)="applyCircuit()">
          <i class="fas fa-save" aria-hidden="true"></i> {{'ProcedureCircuit.Lbl.Import' | translate}} </button>
      </div>
    </div>
  </div>
</p-dialog>